var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

const header = document.querySelector(".header");
const megaMenus = document.querySelectorAll(
  'details[id^="Details-"].mega-menu'
);
let currentOpenMenu = null;
let debounceTimer = null;
let mouseOutTimer = null;

function debounce(func, wait) {
  return function (...args) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(this, args), wait);
  };
}

function closeAllMenus() {
  megaMenus.forEach((menu) => {
    menu.removeAttribute("open");
    menu.querySelector("summary").setAttribute("aria-expanded", "false");
  });
  currentOpenMenu = null;
}

function openMenu(menu) {
  if (currentOpenMenu && currentOpenMenu !== menu) {
    currentOpenMenu.removeAttribute("open");
    currentOpenMenu
      .querySelector("summary")
      .setAttribute("aria-expanded", "false");
  }
  menu.setAttribute("open", "true");
  menu.querySelector("summary").setAttribute("aria-expanded", "true");
  currentOpenMenu = menu;
}

const debouncedMenuHandler = debounce((menu) => {
  if (menu && (!currentOpenMenu || currentOpenMenu !== menu)) {
    openMenu(menu);
  } else if (!menu) {
    closeAllMenus();
  }
}, 100);

header.addEventListener("mouseover", (event) => {
  clearTimeout(mouseOutTimer);
  const menu = event.target.closest('details[id^="Details-"].mega-menu');
  if (menu) {
    debouncedMenuHandler(menu);
  }
});

header.addEventListener("mouseout", (event) => {
  if (!header.contains(event.relatedTarget)) {
    mouseOutTimer = setTimeout(() => {
      closeAllMenus();
    }, 200);
  }
});

megaMenus.forEach((menu) => {
  menu.addEventListener("mouseenter", () => {
    clearTimeout(mouseOutTimer);
  });

  menu.addEventListener("mouseleave", (event) => {
    if (!header.contains(event.relatedTarget)) {
      mouseOutTimer = setTimeout(() => {
        closeAllMenus();
      }, 200);
    }
  });
});

header.addEventListener(
  "touchstart",
  (event) => {
    const menu = event.target.closest('details[id^="Details-"].mega-menu');
    if (menu) {
      if (menu.hasAttribute("open")) {
        return; // Allow link clicking if menu is already open
      }
      event.preventDefault();
      openMenu(menu);
    } else if (!event.target.closest(".header__nav-group")) {
      closeAllMenus();
    }
  },
  { passive: false }
);

document.addEventListener("keyup", (event) => {
  if (event.key === "Escape") {
    closeAllMenus();
  }
});

megaMenus.forEach((menu) => {
  const summary = menu.querySelector("summary");
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");
  if (summary.nextElementSibling && summary.nextElementSibling.id) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }
});

// Close menu when clicking outside
document.addEventListener("click", (event) => {
  if (!event.target.closest(".header")) {
    closeAllMenus();
  }
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    this.input.addEventListener("keydown", this.onKeyDown.bind(this));
  }

  onKeyDown(event) {
    if (event.keyCode == 13) {
      event.preventDefault();
      event.target.blur();
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    this.mobileFacetsInner = this.querySelector(".mobile-facets__inner");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary:not(.menu-drawer-ignore)").forEach(
      (summary) =>
        summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );

    if (this.querySelector(".mobile-facets__drag")) {
      this.querySelector(".mobile-facets__drag").addEventListener(
        "touchstart",
        this.touchCloseStart.bind(this)
      );
      this.querySelector(".mobile-facets__drag").addEventListener(
        "touchmove",
        this.touchCloseMove.bind(this)
      );
      this.querySelector(".mobile-facets__drag").addEventListener(
        "touchend",
        this.touchCloseEnd.bind(this)
      );
    }

    if (this.querySelector(".mobile-facets__close")) {
      this.querySelector(".mobile-facets__close").addEventListener(
        "click",
        (e) => {
          this.closeMenuDrawer(e);
        }
      );
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
    this.setAttribute("open-menu", "true");
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    if (this.id == "tag-filter") {
      window.dataLayer.push({
        event: "openTagFilter",
      });
    }
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    document.body.classList.remove(`menu-drawer-active`);

    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    this.removeAttribute("open-menu");
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  touchCloseStart(e) {
    document.documentElement.classList.add("menu-drawer-move");
    this.mobileFacetsInner.classList.add("mobile-facets__inner--moving");
    this.mobileFacetsDistanceTop =
      this.mobileFacetsInner.getBoundingClientRect().top;
  }

  touchCloseMove(e) {
    this.yLocation = e.touches[0].clientY - this.mobileFacetsDistanceTop;

    if (this.yLocation > 0) {
      this.mobileFacetsInner.style.transform =
        "translateY(" + this.yLocation + "px)";
    }
  }

  touchCloseEnd(e) {
    const lowerHalf = window.innerHeight / 2;

    if (this.yLocation > lowerHalf) {
      this.closeMenuDrawer(e);
    }

    this.mobileFacetsInner.style.transform = null;

    document.documentElement.classList.remove("menu-drawer-move");
    this.mobileFacetsInner.classList.remove("mobile-facets__inner--moving");
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper")?.classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add(`menu-drawer-active`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.dots = this.querySelectorAll(".slider-counter__link--dots .dot");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    this.dots.forEach((dot, index) => {
      dot.addEventListener("click", (e) => {
        e.preventDefault();
        this.slider.scrollTo({
          left: this.sliderItemOffset * index,
        });
      });
    });
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    //  if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.dots.length > 0) {
      this.dots.forEach((dot) => dot.classList.remove("active"));
      this.dots[this.currentPage - 1].classList.add("active");
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;
    this.toggleDisable();
  }

  toggleDisable() {
    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class ThumnailSliderComponent extends SliderComponent {
  constructor() {
    super();
    this.thumbnailList = this.querySelector(".thumbnail-list");
    this.thumbnailList.addEventListener(
      "scroll",
      this.scrollThumbnails.bind(this)
    );
    this.sliderDots = this.querySelectorAll(".slider-counter__link--dots .dot");
    this.scrollThumbnails();
  }

  scrollThumbnails() {
    this.prevButton.removeAttribute("disabled");
    this.nextButton.removeAttribute("disabled");
    console.log(this.thumbnailList.scrollTop);
    if (this.thumbnailList.scrollTop == 0) {
      this.prevButton.style.display = "none";
    } else {
      this.prevButton.style.display = "block";
    }

    if (
      this.thumbnailList.scrollTop ==
      this.thumbnailList.scrollHeight - this.thumbnailList.clientHeight
    ) {
      this.nextButton.style.display = "none";
    } else {
      this.nextButton.style.display = "block";
    }
  }

  onButtonClick(e) {
    this.prevButton.removeAttribute("disabled");
    this.nextButton.removeAttribute("disabled");
    console.log(e.currentTarget.name);
    if (e.currentTarget.name === "next") {
      this.thumbnailList.scrollTo({
        top: this.thumbnailList.scrollHeight - this.thumbnailList.clientHeight,
      });
    } else {
      this.thumbnailList.scrollTo({
        top: 0,
      });
    }
  }

  toggleDisable() {}
}

customElements.define("thumnail-slider-component", ThumnailSliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.centerArrows = this.sliderControlWrapper.dataset.center || "slide";

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  initPages() {
    super.initPages();

    if (this.centerArrows == "image") {
      const image = this.querySelector(".media");

      if (image && image.scrollHeight > 0) {
        const slide = image.closest(".slider__slide");
        const button =
          this.sliderControlWrapper.querySelector(".slider-button");

        const imageWrapperDistance =
          image.getBoundingClientRect().top - slide.getBoundingClientRect().top;

        this.sliderControlWrapper.style.top =
          image.scrollHeight / 2 +
          imageWrapperDistance -
          button.scrollHeight / 2 +
          "px";
      }
    }
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);

    if (this.dataset.uniqueOptions === "true") {
      this.initUniqueOptions();
    }
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (this.dataset.updateMedia === "true") {
      this.updateMedia();
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.updateUpsell();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateUpsell() {
    const upsell = document.querySelector("product-upsell");
    if (upsell) {
      upsell.dataset.productPrice = this.currentVariant.price;
      upsell.dataset.compareProductPrice = this.currentVariant.compare_at_price;

      const upsellInput = upsell.querySelector("input");

      if (upsellInput) {
        upsell.querySelector("input").checked = false;
      }
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const priceDestination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const priceSource = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        if (priceSource && priceDestination)
          priceDestination.innerHTML = priceSource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        const fixedAddToCartDestination = document.getElementById(
          `product-fixed-add-to-cart-${this.dataset.section}`
        );

        const fixedAddToCartSource = html.getElementById(
          `product-fixed-add-to-cart-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        if (fixedAddToCartSource && fixedAddToCartDestination)
          fixedAddToCartDestination.innerHTML = fixedAddToCartSource.innerHTML;

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );

        // temp: updates custom content in coupon template

        const designVariantsDestination = document.getElementById(
          `DesignVariants-${this.dataset.section}`
        );
        const designVariantsSource = html.getElementById(
          `DesignVariants-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        if (designVariantsDestination && designVariantsSource) {
          designVariantsDestination.innerHTML = designVariantsSource.innerHTML;
        }

        // temporary event
        document.dispatchEvent(
          new Event("variantChanged", { bubbles: true, cancelable: false })
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    if (this.dataset.disableCh) return;
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButtons = productForm.querySelectorAll('[name="add"]');
    if (addButtons.length == -1) return;

    addButtons.forEach((addButton) => {
      const addButtonText = addButton.querySelector("span");

      if (disable) {
        addButton.setAttribute("disabled", "disabled");
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute("disabled");
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    });

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  initUniqueOptions() {
    this.selects = document.querySelectorAll("select");
    this.optionsMap = new Map();

    this.selects.forEach((select) => {
      this.optionsMap.set(select, Array.from(select.options));
      select.addEventListener("change", () => this.updateUniqueOptions(select));
    });

    this.selects.forEach(this.updateUniqueOptions.bind(this));
  }
  updateUniqueOptions(changedSelect) {
    const selectedValue = changedSelect.value;

    this.selects.forEach((select) => {
      if (select !== changedSelect) {
        const selectOptions = this.optionsMap.get(select);
        const currentValue = select.value;

        select.innerHTML = "";

        selectOptions.forEach((option) => {
          if (option.value !== selectedValue || option.value === currentValue) {
            const newOption = option.cloneNode(true);
            select.appendChild(newOption);

            if (option.value === currentValue) {
              newOption.selected = true;
            }
          }
        });

        if (currentValue === selectedValue && currentValue !== "") {
          select.value = "";
        }
      }
    });
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      const variantTitle = fieldset.querySelector(
        ".product__selected-variant-title"
      );
      const selectedValue = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;

      if (variantTitle) {
        variantTitle.innerText = selectedValue;
      }

      return selectedValue;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class GlobalModalDialog extends ModalDialog {
  constructor() {
    super();

    this.querySelectorAll(".close").forEach((element) => {
      element.addEventListener("click", (e) => {
        e.preventDefault();
        this.hide();
      });
    });

    this.modalContent = this.querySelector(".popup-modal__content");

    this.querySelector(".popup-modal__drag").addEventListener(
      "touchstart",
      this.touchCloseStart.bind(this)
    );
    this.querySelector(".popup-modal__drag").addEventListener(
      "touchmove",
      this.touchCloseMove.bind(this)
    );
    this.querySelector(".popup-modal__drag").addEventListener(
      "touchend",
      this.touchCloseEnd.bind(this)
    );
    if (
      this.querySelector(".popup-modal__image") &&
      window.matchMedia("(max-width: 750px)").matches
    ) {
      this.changeButtonColor();
      this.querySelector(".popup-modal__content-info").addEventListener(
        "scroll",
        this.scrollHandler.bind(this)
      );
    }
  }
  touchCloseStart(e) {
    document.documentElement.classList.add("modal-move");
    this.modalContent.classList.add("popup-modal__content--moving");
    this.modalDistanceTop = this.modalContent.getBoundingClientRect().top;
  }
  touchCloseMove(e) {
    this.yLocation = e.touches[0].clientY - this.modalDistanceTop;

    if (this.yLocation > 0) {
      this.modalContent.style.transform =
        "translate(-50%, " + this.yLocation + "px)";
    }
  }
  touchCloseEnd(e) {
    const lowerHalf = window.innerHeight / 2;

    if (this.yLocation > lowerHalf) {
      this.hide();
    }

    this.modalContent.style.transform = null;

    document.documentElement.classList.remove("modal-move");
    this.modalContent.classList.remove("popup-modal__content--moving");
  }
  scrollHandler(e) {
    this.changeButtonColor(e.target.scrollTop);
  }
  changeButtonColor(scrollTop = 0) {
    if (scrollTop > 190) {
      this.querySelector(".popup-modal__toggle").style.removeProperty(
        "--color-foreground"
      );
      this.querySelector(".popup-modal__drag").style.removeProperty(
        "--color-foreground"
      );
    } else {
      this.querySelector(".popup-modal__toggle").style.setProperty(
        "--color-foreground",
        "255, 255, 255"
      );
      this.querySelector(".popup-modal__drag").style.setProperty(
        "--color-foreground",
        "255, 255, 255"
      );
    }
  }
}
customElements.define("global-modal-dialog", GlobalModalDialog);
class StickyHeader extends HTMLElement {
  constructor() {
    super();

    const root = document.querySelector(":root");

    root.style.setProperty(
      "--sticky-header-height",
      this.closest("#sticky-header").clientHeight + "px"
    );

    window.addEventListener(
      "resize",
      debounce(() => {
        root.style.setProperty(
          "--sticky-header-height",
          this.closest("#sticky-header").clientHeight + "px"
        );
      }, 100)
    );
  }

  connectedCallback() {
    this.header = document.getElementById("sticky-header");
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector("predictive-search");

    this.header.classList.add("shopify-section-header-sticky");
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.addEventListener("scroll", this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    this.currentScrollTop = scrollTop;
  }

  reset() {
    this.header.classList.remove(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky",
      "animate"
    );
  }

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures || this.header.querySelectorAll("header-menu");
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal =
      this.searchModal || this.header.querySelector("details-modal");
    this.searchModal.close(false);
  }
}

customElements.define("sticky-header", StickyHeader);

class AnnouncementSliderComponent extends SliderComponent {
  constructor() {
    super();
    this.enableSliderLooping = true;
    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));

    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), 6000);
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".announcement__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}
customElements.define(
  "announcement-slider-component",
  AnnouncementSliderComponent
);
class ConfirmInstagram extends HTMLElement {
  constructor() {
    super();
    this.igEmbeddedCode = this.querySelector(".instagram-embedded__code");
    this.loadIgContentBtn = this.querySelector(".instagram-embedded__button");
    this.embedImage = this.querySelector(".instagram-embedded__image");
    this.loadIgContentBtn.addEventListener(
      "click",
      this.handleBtnClick.bind(this)
    );
    this.showMoreButton = this.querySelector(".instagram-embedded__show-more");

    this.showMoreButton.addEventListener("click", () => {
      this.igEmbeddedCode.classList.add("instagram-embedded__code--open");
    });
  }

  handleBtnClick() {
    this.igEmbeddedCode.innerHTML = this.igEmbeddedCode.innerText;
    this.igEmbeddedCode.classList.remove("hidden");
    this.igEmbeddedCode.classList.add("instagram-embedded__code--loaded");
    this.loadIgContentBtn.parentNode.classList.add("hidden");
    this.embedImage.classList.add("hidden");

    const script = document.createElement("script");

    script.id = "instagram-embed-js";
    script.src = "//www.instagram.com/embed.js";
    script.async = true;
    script.defer = true;
    script.onload = "window.instgrm.Embeds.process()";

    if (!document.querySelector("#instagram-embed-js")) {
      document.body.append(script);
    } else {
      window.instgrm.Embeds.process();
    }
  }
}

customElements.define("confirm-instagram", ConfirmInstagram);

(() => {
  document.addEventListener(
    "AppstleSubscription:SubscriptionWidget:SellingPlanSelected",
    () => {
      const subscriptionOption = document.querySelector(
        "[name='selling_plan'][value]:not([value=''])"
      );
      const subscriptionDescriptionList = subscriptionOption
        .closest(".appstle_subscription_wrapper_option")
        .querySelector(
          ".appstle_subscribe_option > .appstleSellingPlanDescription ul"
        );

      const selectedVariantTitle = document.querySelector(
        ".product__selected-variant-title"
      );

      const subscriptionDeliveryText =
        window.subscriptionStrings.orderFrequency.replace(
          "[variant_title]",
          selectedVariantTitle.textContent
        );

      const orderFrequencyItem = subscriptionDescriptionList.querySelector(
        "li.appstleCustom__order-frequency"
      );

      if (orderFrequencyItem) {
        orderFrequencyItem.textContent = subscriptionDeliveryText;
      } else {
        const orderFrequencyElement = document.createElement("li");
        orderFrequencyElement.className = "appstleCustom__order-frequency";
        orderFrequencyElement.textContent = subscriptionDeliveryText;

        subscriptionDescriptionList.append(orderFrequencyElement);
      }
    }
  );
})();

// Klaviyo "Added to cart"-Event

(() => {
  document.addEventListener("add-to-cart-submit", (e) => {
    var _learnq = window._learnq || [];

    fetch(`${routes.cart_url}`, {
      ...fetchConfig(),
    })
      .then((response) => response.json())
      .then((cart) => {
        const cartItems = cart.items.map((item) => item.product_id);

        var item = {
          Name: e.detail.product.title,
          ProductID: e.detail.product.id,
          ImageURL: e.detail.product.image,
          URL: e.detail.product.url,
          Brand: e.detail.product.vendor,
          Price: Shopify.formatMoney(
            e.detail.product.price,
            "{{amount_with_comma_separator}}€"
          ),
          CompareAtPrice: Shopify.formatMoney(
            e.detail.product.original_price,
            "{{amount_with_comma_separator}}€"
          ),
          CartItems: cartItems,
        };
        _learnq.push(["track", "Added to Cart", item]);
      });
  });
})();

class BirthdayField extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.isChangeMode = false;
    this.body = document.querySelector("body");
    this.querySelector("#saveBithday").addEventListener(
      "click",
      this.handleSave.bind(this)
    );
    this.querySelector(".birthdayChange").addEventListener(
      "click",
      this.toggleChange.bind(this)
    );
    this.querySelector(".birthdayCreate > a").addEventListener(
      "click",
      this.showForm.bind(this)
    );
  }

  showForm(e) {
    e.preventDefault();
    this.classList.remove("not-set");
    this.toggleChange();
  }

  toggleChange(e) {
    if (e) {
      e.preventDefault();
    }
    this.isChangeMode = !this.isChangeMode;
    if (this.isChangeMode) {
      this.querySelector("[name='birthdayMonth']").removeAttribute("disabled");
      this.querySelector("[name='birthdayDay']").removeAttribute("disabled");
      this.classList.add("change-mode");
    } else {
      this.querySelector("[name='birthdayMonth']").setAttribute(
        "disabled",
        true
      );
      this.querySelector("[name='birthdayDay']").setAttribute("disabled", true);
      this.classList.remove("change-mode");
    }
  }

  handleSave() {
    const { customerDigest, customerEmail, customerId, shop } =
      document.querySelector("[data-customer-digest]").dataset;
    const birthdayDay = parseInt(
      this.querySelector("[name='birthdayDay']").value
    );
    const birthdayMonth = parseInt(
      this.querySelector("[name='birthdayMonth']").value
    );

    if (
      birthdayDay < 0 ||
      birthdayDay > 31 ||
      birthdayMonth < 0 ||
      birthdayMonth > 12
    ) {
      this.classList.add("error");
      return;
    }
    this.classList.remove("error");

    const data = {
      customer: {
        id: customerId,
        email: customerEmail,
      },
      shop,
      digest: customerDigest,
      birthdayDay,
      birthdayMonth,
    };

    fetch(`https://launcher.api.influence.io/launcher/v1/customer/birthday`, {
      body: JSON.stringify(data),
      method: "PUT",
      headers: {
        accept: "application/json",
        "content-type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((json) => {
        fetch(
          `https://innonature-klaviyo-api-e6d6c798a547.herokuapp.com/saveKlaviyo`,
          {
            body: JSON.stringify({
              email: customerEmail,
              day: birthdayDay,
              month: birthdayMonth,
            }),
            method: "POST",
            headers: {
              accept: "application/json",
              "content-type": "application/json",
            },
          }
        )
          .then((response) => response.json())
          .then((json) => {
            this.toggleChange();
          });
        this.toggleChange();
      });
  }

  init() {
    if (document.querySelector("[data-customer-digest]")) {
      const { customerDigest, customerEmail, customerId, shop } =
        document.querySelector("[data-customer-digest]").dataset;
      const params = new URLSearchParams({
        customer_id: customerId,
        customer_email: customerEmail,
        shop,
        digest: customerDigest,
      });

      fetch(`https://launcher.api.influence.io/launcher/v1/customer?${params}`)
        .then((response) => response.json())
        .then((json) => {
          if (json.birthdayDay && json.birthdayMonth) {
            this.querySelector("[name='birthdayMonth']").value =
              json.birthdayMonth;
            this.querySelector("[name='birthdayDay']").value = json.birthdayDay;
            this.classList.remove("not-set");
          } else {
            this.classList.add("not-set");
          }
        });
    }
  }
}
customElements.define("birthday-field", BirthdayField);

class ProductLaunchForm extends HTMLElement {
  constructor() {
    super();

    this.loading = false;

    this.klaviyoSiteId = this.dataset.klaviyoSiteId;
    this.klaviyoListId = this.dataset.klaviyoListId;
    this.productId = this.dataset.productId;

    this.emailField = this.querySelector("input[type='email']");
    this.newsletterField = this.querySelector("input[type='checkbox']");
    this.submitButton = this.querySelector("button");

    this.querySelector("form").addEventListener(
      "submit",
      this.handleSubmit.bind(this)
    );
  }

  async handleSubmit(event) {
    event.preventDefault();

    if (!this.loading) {
      this.loading = true;
      this.submitButton.classList.add("button--loading");
    }

    const form = event.target;
    const data = new FormData(form);

    const email = data.get("launch_email");
    const newsletterSubscribe = data.get("launch_subscribe_newsletter");

    if (!email || email === "") {
      this.emailField.parentElement.classList.add("field--with-error");
      this.querySelector("#launchEmailError").classList.remove("hidden");
      this.emailField.ariaInvalid = true;
    } else {
      this.emailField.parentElement.classList.remove("field--with-error");
      this.querySelector("#launchEmailError").classList.add("hidden");
      this.emailField.ariaInvalid = false;
    }

    try {
      const metricResponse = await this.sendMetricEvent(email);

      if (newsletterSubscribe === "on") {
        const newsletterResponse = await this.sendSubscriptionEvent(email);

        if (!newsletterResponse.ok) {
          throw new Error(newsletterResponse.errors);
        }
      }

      if (metricResponse.ok) {
        this.querySelector(".product__launch-error").classList.add("hidden");
        this.querySelector(".product__launch-success").classList.remove(
          "hidden"
        );
        this.submitButton.remove();

        this.querySelectorAll("input").forEach((input) => {
          input.parentElement.remove();
        });
      } else {
        throw new Error(metricResponse.errors);
      }
    } catch (error) {
      this.querySelector(".product__launch-error").classList.remove("hidden");
    }

    this.loading = false;
    this.submitButton.classList.remove("button--loading");
  }
  async sendMetricEvent(email) {
    const options = {
      method: "POST",
      headers: {
        accept: "application/json",
        revision: "2024-02-15",
        "content-type": "application/json",
      },
      body: JSON.stringify({
        data: {
          type: "event",
          attributes: {
            properties: { productId: this.productId },
            metric: {
              data: {
                type: "metric",
                attributes: { name: "Subscribed to Launch" },
              },
            },
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email,
                },
              },
            },
          },
        },
      }),
    };

    const metricResponse = await fetch(
      `https://a.klaviyo.com/client/events/?company_id=${this.klaviyoSiteId}`,
      options
    );

    return metricResponse;
  }
  async sendSubscriptionEvent(email) {
    const options = {
      method: "POST",
      headers: { revision: "2024-02-15", "content-type": "application/json" },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            custom_source: "Product Launch",
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email,
                },
              },
            },
          },
          relationships: {
            list: { data: { type: "list", id: this.klaviyoListId } },
          },
        },
      }),
    };

    const newsletterResponse = await fetch(
      `https://a.klaviyo.com/client/subscriptions/?company_id=${this.klaviyoSiteId}`,
      options
    );

    return newsletterResponse;
  }
}

customElements.define("product-launch-form", ProductLaunchForm);

class TabbedNavigation extends HTMLElement {
  constructor() {
    super();

    this.tabs = [];

    this.firstTab = null;
    this.lastTab = null;

    this.tabs = Array.from(this.querySelectorAll("[role=tab]"));
    this.tabpanels = [];

    if (this.tabs.length <= 0) {
      return;
    }

    for (var i = 0; i < this.tabs.length; i++) {
      var tab = this.tabs[i];
      var tabpanel = document.getElementById(tab.getAttribute("aria-controls"));

      tab.tabIndex = -1;
      tab.setAttribute("aria-selected", "false");
      this.tabpanels.push(tabpanel);

      tab.addEventListener("keydown", this.onKeydown.bind(this));
      tab.addEventListener("click", this.onClick.bind(this));

      if (!this.firstTab) {
        this.firstTab = tab;
      }
      this.lastTab = tab;
    }

    this.setSelectedTab(this.firstTab, false);
  }

  setSelectedTab(currentTab, setFocus) {
    if (typeof setFocus !== "boolean") {
      setFocus = true;
    }
    for (var i = 0; i < this.tabs.length; i++) {
      var tab = this.tabs[i];
      if (currentTab === tab) {
        tab.setAttribute("aria-selected", "true");
        tab.removeAttribute("tabindex");
        this.tabpanels[i].classList.remove("is-hidden");
        if (setFocus) {
          tab.focus();
        }
      } else {
        tab.setAttribute("aria-selected", "false");
        tab.tabIndex = -1;
        this.tabpanels[i].classList.add("is-hidden");
      }
    }
  }

  setSelectedToPreviousTab(currentTab) {
    var index;

    if (currentTab === this.firstTab) {
      this.setSelectedTab(this.lastTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index - 1]);
    }
  }

  setSelectedToNextTab(currentTab) {
    var index;

    if (currentTab === this.lastTab) {
      this.setSelectedTab(this.firstTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index + 1]);
    }
  }

  /* EVENT HANDLERS */

  onKeydown(event) {
    var tgt = event.currentTarget,
      flag = false;

    switch (event.key) {
      case "ArrowLeft":
        this.setSelectedToPreviousTab(tgt);
        flag = true;
        break;

      case "ArrowRight":
        this.setSelectedToNextTab(tgt);
        flag = true;
        break;

      case "Home":
        this.setSelectedTab(this.firstTab);
        flag = true;
        break;

      case "End":
        this.setSelectedTab(this.lastTab);
        flag = true;
        break;

      default:
        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onClick(event) {
    this.setSelectedTab(event.currentTarget);
  }
}

customElements.define("tabbed-navigation", TabbedNavigation);

class AnnouncementPromotions extends HTMLElement {
  constructor() {
    super();

    const codeContentWrapperEl = this.querySelector(
      ".announcement-promotions__code-content-wrapper"
    );

    const root = document.querySelector(":root");

    root.style.setProperty(
      "--announcement-promotions-height",
      this.closest("#shopify-section-announcement-promotions").clientHeight +
        "px"
    );

    this.treshold =
      document.querySelector("#shopify-section-announcement-sliding")
        .clientHeight +
      document.querySelector("#shopify-section-announcement-promotions")
        .clientHeight +
      document.querySelector("#sticky-header").clientHeight;

    window.addEventListener(
      "resize",
      debounce(() => {
        root.style.setProperty(
          "--announcement-promotions-height",
          this.closest("#shopify-section-announcement-promotions")
            .clientHeight + "px"
        );
        this.treshold =
          document.querySelector("#shopify-section-announcement-sliding")
            .clientHeight +
          document.querySelector("#shopify-section-announcement-promotions")
            .clientHeight +
          document.querySelector("#sticky-header").clientHeight;
      }, 100)
    );

    if (codeContentWrapperEl) {
      const code = this.querySelector(
        ".announcement-promotions__code-content"
      ).innerText.trim();

      const snackBar = document.querySelector("snack-bar");

      const snackBarTemplate = this.querySelector(
        ".announcement-promotions__snack-bar-template"
      ).content.cloneNode(true);

      const snackBarText = snackBarTemplate.querySelector(
        ".announcement-promotions__snack-bar-text"
      );
      const snackBarIcon = snackBarTemplate.querySelector(
        ".announcement-promotions__snack-bar-icon"
      );

      codeContentWrapperEl.addEventListener("click", () => {
        navigator.clipboard.writeText(code);

        snackBar.querySelector('div[slot="icon"]').innerHTML =
          snackBarIcon.innerHTML;
        snackBar.querySelector('div[slot="text"]').textContent =
          snackBarText.textContent;
      });
    }

    this.animationTicking = false;

    window.addEventListener("scroll", this.handleScroll.bind(this), {
      passive: true,
    });

    this.handleScroll();

    if (this.querySelector(".announcement-promotions__countdown")) {
      this.startCountdown();
    }
  }
  handleScroll() {
    if (!this.animationTicking) {
      window.requestAnimationFrame(() => {
        const scrollPosition = window.scrollY;

        if (
          scrollPosition >
          this.treshold -
            document.querySelector("#shopify-section-announcement-promotions")
              .clientHeight
        ) {
          document.body.classList.add("announcement-promotions-scrolled");
        } else {
          document.body.classList.remove("announcement-promotions-scrolled");
        }

        this.animationTicking = false;
      });

      this.animationTicking = true;
    }
  }
  startCountdown() {
    const countdownStartDate = new Date(this.dataset.countdownStart).getTime();
    const countdownDueDate = new Date(this.dataset.countdownEnd).getTime();

    let countdown = setInterval(
      function () {
        const now = new Date().getTime();

        const dateDifference = (countdownDueDate - now) / 1000;

        const hoursLeft = Math.floor(dateDifference / 60 / 60);
        const minutesLeft = Math.floor(((dateDifference / 60 / 60) % 1) * 60);
        const secondsLeft = Math.floor(
          ((((dateDifference / 60 / 60) % 1) * 60) % 1) * 60
        );

        const hours = ("0" + hoursLeft).slice(-2);
        const minutes = ("0" + minutesLeft).slice(-2);
        const seconds = ("0" + secondsLeft).slice(-2);

        this.querySelector(
          ".announcement__countdown-numbers--hours"
        ).innerHTML = this.formatNumberParts(hours.split(""));
        this.querySelector(
          ".announcement__countdown-numbers--minutes"
        ).innerHTML = this.formatNumberParts(minutes.split(""));
        this.querySelector(
          ".announcement__countdown-numbers--seconds"
        ).innerHTML = this.formatNumberParts(seconds.split(""));

        if (dateDifference < 0) {
          clearInterval(countdown);
        }
      }.bind(this),
      1000
    );
  }

  formatNumberParts(n) {
    let numbersHtml = "";

    for (var i = 0; i < n.length; i++) {
      numbersHtml +=
        '<span class="announcement__countdown-number">' + n[i] + "</span>";
    }

    return numbersHtml;
  }
}

customElements.define("announcement-promotions", AnnouncementPromotions);

class SnackBar extends HTMLElement {
  constructor() {
    super();

    this.attachShadow({ mode: "open" });

    const template = document.getElementById("SnackbarTemplate");
    const templateContent = template.content.cloneNode(true);

    document.getElementById("Snackbar").shadowRoot.appendChild(templateContent);

    new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.target.className.indexOf("snack-bar") > -1) {
          this.classList.add("snack-bar--show");

          setTimeout(() => {
            this.classList.remove("snack-bar--show");
          }, 3000);
        }
      }
    }).observe(this, { childList: true, characterData: true, subtree: true });
  }
}

customElements.define("snack-bar", SnackBar);

class MetafieldVariantRadios extends HTMLElement {
  constructor() {
    super();

    this.selectedVariantTitle = this.querySelector(
      ".product__selected-variant-title"
    );

    this.productPrice = parseFloat(this.dataset.productPrice / 100);
    this.productCompareAtPrice = parseFloat(
      this.dataset.productCompareAtPrice / 100
    );

    this.priceEl = document.querySelector(".product .price");
    this.salePriceEl = this.priceEl.querySelector(".price-item--sale");
    this.regularPriceEls = this.priceEl.querySelectorAll(
      ".price-item--regular"
    );

    this.variantRadios = this.querySelectorAll("input[type='radio']");
    this.variantRadios.forEach((radio) => {
      radio.addEventListener("change", this.handleRadioChange.bind(this));
    });

    window.addEventListener("pageshow", () => {
      this.querySelector("input[type='radio']:checked").dispatchEvent(
        new Event("change")
      );
    });
  }
  handleRadioChange(event) {
    this.selectedVariantTitle.textContent =
      event.currentTarget.dataset.optionName;

    const quantity = parseInt(event.currentTarget.value);
    const productPrice =
      this.productCompareAtPrice > this.productPrice
        ? this.productCompareAtPrice
        : this.productPrice;

    const pricePerQuantity = Number(
      Math.round(
        (this.productPrice / 100) *
          (100 - parseInt(event.currentTarget.dataset.variantDiscount)) +
          "e2"
      ) + "e-2"
    );

    const finalPrice = parseFloat(quantity * pricePerQuantity).toFixed(2);

    this.regularPriceEls.forEach((el) => {
      el.textContent = event.currentTarget.dataset.variantSalePrice;
    });

    if (finalPrice < productPrice * quantity) {
      this.priceEl.querySelector(
        ".tooltiptext"
      ).textContent = `Spare ${Math.round(
        ((productPrice * quantity - finalPrice) / (productPrice * quantity)) *
          100
      )}%`;

      this.priceEl.classList.add("price--on-sale");

      this.salePriceEl.textContent =
        event.currentTarget.dataset.variantSalePrice;
      this.regularPriceEls.forEach((el) => {
        el.textContent = event.currentTarget.dataset.variantPrice;
      });
    } else {
      this.priceEl.classList.remove("price--on-sale");
      this.regularPriceEls.forEach((el) => {
        el.textContent = event.currentTarget.dataset.variantSalePrice;
      });
    }
  }
}

customElements.define("metafield-variant-radios", MetafieldVariantRadios);

class CollapsibleText extends HTMLElement {
  constructor() {
    super();

    this.collapsibleEl = this.querySelector(".collapsible-text");
    this.collapsibleInner = this.collapsibleEl.querySelector(
      ".collapsible-text__inner"
    );
    this.toggleButton = this.querySelector(".collapsible-text__toggle-button");

    this.collapsibleEl.style.setProperty(
      "--collapsible-text-height",
      `${this.collapsibleEl.getBoundingClientRect().height}px`
    );

    if (
      this.collapsibleInner.scrollHeight > this.collapsibleInner.clientHeight
    ) {
      this.toggleButton.addEventListener("click", () => {
        if (
          this.collapsibleEl.classList.contains("collapsible-text--expanded")
        ) {
          this.close();
        } else {
          this.open();
        }
      });
    } else {
      this.toggleButton.classList.add("hidden");
      this.collapsibleEl.classList.add("collapsible-text--expanded");
    }
  }
  open() {
    this.collapsibleEl.classList.remove("collapsible-text--truncated");
    this.toggleButton.textContent = this.toggleButton.dataset.textCollapsed;

    window.requestAnimationFrame(() => {
      const collapsibleInnerRect =
        this.collapsibleInner.getBoundingClientRect();
      this.collapsibleEl.style.setProperty(
        "--collapsible-text-height-expanded",
        `${collapsibleInnerRect.height}px`
      );
      this.collapsibleEl.classList.add("collapsible-text--expanded");
    });
  }
  close() {
    this.collapsibleEl.classList.remove("collapsible-text--expanded");
    this.toggleButton.textContent = this.toggleButton.dataset.textUncollapsed;

    setTimeout(() => {
      this.collapsibleEl.classList.add("collapsible-text--truncated");
    }, 300);
  }
}

customElements.define("collapsible-text", CollapsibleText);

class AnnouncementSliding extends SliderComponent {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

    if (!this.slider) return;

    const root = document.querySelector(":root");

    this.treshold =
      document.querySelector("#shopify-section-announcement-sliding")
        .clientHeight +
      document.querySelector("#shopify-section-announcement-promotions")
        .clientHeight +
      document.querySelector("#sticky-header").clientHeight;

    window.addEventListener(
      "resize",
      debounce(() => {
        root.style.setProperty(
          "--announcement-sliding-height",
          this.closest("#shopify-section-announcement-sliding").clientHeight +
            "px"
        );
        this.treshold =
          document.querySelector("#shopify-section-announcement-sliding")
            .clientHeight +
          document.querySelector("#shopify-section-announcement-promotions")
            .clientHeight +
          document.querySelector("#sticky-header").clientHeight;
      }, 100)
    );

    this.enableSliderLooping = true;
    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));

    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), 3000);

    this.animationTicking = false;

    if (this.dataset.hideOnScroll === "true") {
      window.addEventListener("scroll", this.handleScroll.bind(this), {
        passive: true,
      });
      this.handleScroll();
    }
  }
  handleScroll() {
    if (!this.animationTicking) {
      window.requestAnimationFrame(() => {
        const scrollPosition = window.scrollY;

        if (
          scrollPosition >
          this.treshold -
            document.querySelector("#shopify-section-announcement-sliding")
              .clientHeight
        ) {
          document.body.classList.add("announcement-sliding-scrolled");
        } else {
          document.body.classList.remove("announcement-sliding-scrolled");
        }

        this.animationTicking = false;
      });

      this.animationTicking = true;
    }
  }
  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollTop +
          this.slider.querySelector(".announcement-sliding__slide")
            .clientHeight;

    this.slider.scrollTo({
      top: slideScrollPosition,
    });
  }
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientHeight > 0
    );
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
    this.slidesPerPage = Math.floor(
      (this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    this.update();
  }
  update() {
    this.currentPage =
      Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
  }
}
customElements.define("announcement-sliding", AnnouncementSliding);

class AccordionFooter extends HTMLElement {
  constructor() {
    super();

    this.accordionDetails = this.querySelector("details");
    this.accordionSummary = this.querySelector("summary");

    this.accordionSummary.addEventListener("click", this.handleOpen.bind(this));
    window.addEventListener("resize", this.openOrClose.bind(this));
    this.openOrClose();
  }
  openOrClose() {
    if (window.matchMedia("(min-width: 750px)").matches) {
      this.accordionDetails.setAttribute("open", "open");
      this.accordionSummary.setAttribute("aria-expanded", true);
    } else {
      this.accordionDetails.removeAttribute("open");
      this.accordionSummary.setAttribute("aria-expanded", false);
    }
  }
  handleOpen(e) {
    e.currentTarget.setAttribute(
      "aria-expanded",
      !e.currentTarget.closest("details").hasAttribute("open")
    );
  }
}

customElements.define("accordion-footer", AccordionFooter);

document.addEventListener("DOMContentLoaded", function () {
  const popupOverlay = document.getElementById("popupOverlay");
  const desktopPopup = document.getElementById("popup1");
  const mobilePopup = document.getElementById("popup-mobile");
  const closeMobileBtn = document.querySelector(".close-mobile-popup");
  let touchStartY = 0;
  let touchEndY = 0;

  function showPopup() {
    popupOverlay.style.display = "block"; // Show overlay first
    setTimeout(() => popupOverlay.classList.add("active"), 10); // Smooth fade-in

    if (window.innerWidth <= 749) {
      // Mobile Popup
      mobilePopup.style.display = "block";
      mobilePopup.style.opacity = "0";
      mobilePopup.style.bottom = "-100%";

      setTimeout(() => {
        mobilePopup.style.opacity = "1";
        mobilePopup.style.bottom = "0";
      }, 10);
    } else {
      // Desktop Popup
      desktopPopup.style.display = "block";
      desktopPopup.style.opacity = "0";
      desktopPopup.style.transform = "translate(-50%, -50%) scale(0.85)";

      setTimeout(() => {
        desktopPopup.style.opacity = "1";
        desktopPopup.style.transform = "translate(-50%, -50%) scale(1)";
      }, 10);
    }

    document.body.style.overflow = "hidden"; // Prevent background scroll
  }

  function hidePopup() {
    if (window.innerWidth <= 749) {
      // Mobile Popup
      mobilePopup.style.opacity = "0";
      mobilePopup.style.bottom = "-100%";

      setTimeout(() => (mobilePopup.style.display = "none"), 400);
    } else {
      // Desktop Popup
      desktopPopup.style.opacity = "0";
      desktopPopup.style.transform = "translate(-50%, -50%) scale(0.85)";

      setTimeout(() => (desktopPopup.style.display = "none"), 400);
    }

    setTimeout(() => {
      popupOverlay.classList.remove("active");
      popupOverlay.style.display = "none";
    }, 400);

    document.body.style.overflow = "";
  }

  // Open Popup
  document.querySelectorAll(".pdp-link-ab-popup").forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      showPopup();
    });
  });

  document.querySelector(".pdp_btn--abtest")?.addEventListener("click", hidePopup);
  closeMobileBtn?.addEventListener("click", hidePopup);

  // Mobile touch swipe to close
  mobilePopup?.addEventListener("touchstart", function (e) {
    touchStartY = e.touches[0].clientY;
  });

  mobilePopup?.addEventListener("touchmove", function (e) {
    touchEndY = e.touches[0].clientY;
    let diff = touchEndY - touchStartY;
    if (diff > 50) {
      mobilePopup.classList.add("touching");
      mobilePopup.style.bottom = `-${diff}px`;
    }
  });

  mobilePopup?.addEventListener("touchend", function () {
    mobilePopup.classList.remove("touching");
    if (touchEndY - touchStartY > 100) {
      hidePopup();
    } else {
      mobilePopup.style.bottom = "0";
    }
  });

  popupOverlay?.addEventListener("click", function (e) {
    if (e.target === popupOverlay) hidePopup();
  });
});

(() => {
  const announcementSliding = document.querySelector(
    "#shopify-section-announcement-sliding"
  );
  const stickyHeader = document.querySelector("#sticky-header");
  const announcementPromotions = document.querySelector(
    "#shopify-section-announcement-promotions"
  );
  const toggleSwitchAudience = document.querySelector(
    ".toggle-switch-audience"
  );

  const announcementSlidingHeight = announcementSliding?.offsetHeight || 0;
  const stickyHeaderHeight = stickyHeader?.offsetHeight || 0;
  const announcementPromotionsHeight =
    announcementPromotions?.offsetHeight || 0;
  const toggleSwitchAudienceHeight = toggleSwitchAudience?.offsetHeight || 0;

  document.documentElement.style.setProperty(
    "--announcement-sliding-height",
    `${announcementSlidingHeight}px`
  );
  document.documentElement.style.setProperty(
    "--sticky-header-height",
    `${stickyHeaderHeight}px`
  );
  document.documentElement.style.setProperty(
    "--announcement-promotions-height",
    `${announcementPromotionsHeight}px`
  );
  document.documentElement.style.setProperty(
    "--toggle-switch-audience-height",
    `${toggleSwitchAudienceHeight}px`
  );

  // Update properties on window resize
  window.addEventListener(
    "resize",
    debounce(() => {
      // Re-measure heights after resize
      const announcementSlidingHeight = announcementSliding
        ? announcementSliding.offsetHeight
        : 0;
      const stickyHeaderHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
      const announcementPromotionsHeight = announcementPromotions
        ? announcementPromotions.offsetHeight
        : 0;
      const toggleSwitchAudienceHeight = toggleSwitchAudience
        ? toggleSwitchAudience.offsetHeight
        : 0;

      // Update CSS variables with new measurements
      document.documentElement.style.setProperty(
        "--announcement-sliding-height",
        `${announcementSlidingHeight}px`
      );
      document.documentElement.style.setProperty(
        "--sticky-header-height",
        `${stickyHeaderHeight}px`
      );
      document.documentElement.style.setProperty(
        "--announcement-promotions-height",
        `${announcementPromotionsHeight}px`
      );
      document.documentElement.style.setProperty(
        "--toggle-switch-audience-height",
        `${toggleSwitchAudienceHeight}px`
      );
    }, 250)
  ); // 250ms debounce to avoid excessive calculations during resize
})();

// Adding a global function to handle the visibility of the subscription options

(() => {
  const handleSubscriptionUpdate = () => {
    const appstleOption = document.querySelector(
      ".appstle_subscription_radio_wrapper input"
    );
    const variantInputs = document.querySelectorAll(
      ".product-form__variant-grid input"
    );

    if (!variantInputs.length) return;

    const isSubscriptionActive = appstleOption?.checked === true;

    requestAnimationFrame(() => {
      let firstInput = null;

      variantInputs.forEach((input, index) => {
        if (index === 0) {
          firstInput = input;
        } else {
          const sibling = input.nextElementSibling;

          if (sibling) {
            if (isSubscriptionActive) {
              input.classList.add("hidden");
              sibling.classList.add("hidden");
            } else {
              input.classList.remove("hidden");
              sibling.classList.remove("hidden");
            }
          }
        }
      });

      if (isSubscriptionActive && firstInput) {
        if (!firstInput.checked) {
          firstInput.checked = true;
          firstInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    });
  };

  const debouncedHandler = debounce(handleSubscriptionUpdate, 500);

  document.addEventListener(
    "AppstleSubscription:SubscriptionWidget:SubscriptionWidgetUpdated",
    debouncedHandler,
    { passive: true }
  );
})();

// Remove customerAudience from sessionStorage on DOMContentLoaded

// document.addEventListener("DOMContentLoaded", () => {
//   sessionStorage.removeItem("customerAudience");
// });

class ProductBadge extends HTMLElement {
  constructor() {
    super();

    this.startDate = this.dataset.startDate;
    this.endDate = this.dataset.endDate;
  }

  connectedCallback() {
    const now = new Date();
    const startDate = new Date(this.startDate);
    const endDate = new Date(this.endDate);

    if (now >= startDate && now <= endDate) {
      this.classList.remove("hidden");
    }
  }
}

customElements.define("product-badge", ProductBadge);
